/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, plural: NonNullable<unknown> }} Cover_Letters_CountInputs */

const en_cover_letters_count = /** @type {(inputs: Cover_Letters_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} cover letter${i?.plural}`)
};

const de_cover_letters_count = /** @type {(inputs: Cover_Letters_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Anschreiben`)
};

const fr_cover_letters_count = /** @type {(inputs: Cover_Letters_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} lettre${i?.plural} de motivation`)
};

const es_cover_letters_count = /** @type {(inputs: Cover_Letters_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} carta${i?.plural} de presentación`)
};

const it_cover_letters_count = /** @type {(inputs: Cover_Letters_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} lettera${i?.plural} di presentazione`)
};

const nl_cover_letters_count = /** @type {(inputs: Cover_Letters_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} motivatiebrief${i?.plural}`)
};

const pl_cover_letters_count = /** @type {(inputs: Cover_Letters_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} list${i?.plural} motywacyjny`)
};

const fi_cover_letters_count = /** @type {(inputs: Cover_Letters_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} saatekirje${i?.plural}`)
};

const da_cover_letters_count = /** @type {(inputs: Cover_Letters_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ansøgningsbrev${i?.plural}`)
};

const sv_cover_letters_count = /** @type {(inputs: Cover_Letters_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} personligt brev${i?.plural}`)
};

/**
* | output |
* | --- |
* | "{count} cover letter{plural}" |
*
* @param {Cover_Letters_CountInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_count = /** @type {((inputs: Cover_Letters_CountInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_CountInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_count(inputs)
	if (locale === "fr") return fr_cover_letters_count(inputs)
	if (locale === "es") return es_cover_letters_count(inputs)
	if (locale === "it") return it_cover_letters_count(inputs)
	if (locale === "nl") return nl_cover_letters_count(inputs)
	if (locale === "pl") return pl_cover_letters_count(inputs)
	if (locale === "fi") return fi_cover_letters_count(inputs)
	if (locale === "da") return da_cover_letters_count(inputs)
	if (locale === "sv") return sv_cover_letters_count(inputs)
	return en_cover_letters_count(inputs)
});